import { Injectable } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandleService {
  infoSwalComponentRef: SwalComponent;
  errorSwalComponentRef: SwalComponent;
  BASE_URL_RDO: string = environment.BASE_URL_RDO;

  constructor() {}

  redirectToNotFound(response?) {
    if (response) this.throwConsoleError(response);
  }

  redirectToHome(response?) {
    if (response) this.throwConsoleError(response);

    window.location.href = window.location.origin;
  }

  setNewInfoSwalReference(swalReference: SwalComponent) {
    if (!this.infoSwalComponentRef) this.infoSwalComponentRef = swalReference;
  }

  throwMessageInfo(data) {
    if (typeof data == 'string') {
      this.infoSwalComponentRef.text = data;
      this.infoSwalComponentRef.fire();
    } else {
      if (data.error && data.error.message) {
        this.infoSwalComponentRef.text = data.error.message;
        this.infoSwalComponentRef.fire();
      } else {
        console.info('Message throwed: ', data);
      }
    }
  }

  setNewErrorSwalReference(swalReference: SwalComponent) {
    if (!this.errorSwalComponentRef) this.errorSwalComponentRef = swalReference;
  }

  throwMessageError(data) {
    if (typeof data == 'string') {
      this.errorSwalComponentRef.text = data;
      this.errorSwalComponentRef.fire();
    } else {
      if (data.error && data.error.message) {
        this.errorSwalComponentRef.text = data.error.message;
        this.errorSwalComponentRef.fire();
      } else {
        console.error('Message error throwed: ', data);
      }
    }
  }

  throwConsoleError(error) {
    console.error('Error throwed: ', error);
  }

  throwConsoleLog(error) {
    console.log('Log throwed: ', error);
  }

  throwSwalError(message) {
    Swal.fire({
      position: 'center',
      icon: 'error',
      text: message,
      showConfirmButton: false,
      timer: 1500,
    });
  }
}
